import { ObjectValues } from 'helpers/types';

export enum AuthModal {
  SIGN_UP = 'signup',
  RECOVER = 'recover',
  LOGIN = 'login',
  SETUP_PASSWORD = 'setupPassword',
  ENTER_CODE = 'enterCode'
}

export enum StepQuantity {
  ONE = 1,
  TWO = 2,
}

export const SOCIAL_PROVIDERS = {
  FACEBOOK: 'Facebook',
  GOOGLE: 'Google',
} as const;

export type ISocialProviders = ObjectValues<typeof SOCIAL_PROVIDERS>;

export interface IModalProps {
  isModalOpened: boolean;
  onModalClose(): void;
}

export interface IModalOpened extends Pick<IModalProps, 'isModalOpened'> {}

export enum CognitoExceptions {
  CodeMismatchException = 'CodeMismatchException',
  ExpiredCodeException = 'ExpiredCodeException',
  UsernameExistsException = 'UsernameExistsException',
  NotAuthorizedException = 'NotAuthorizedException',
  UserAlreadyAuthenticatedException = 'UserAlreadyAuthenticatedException',
  UserNotConfirmedException = 'UserNotConfirmedException',
}

export interface IStepFormProps {
  onClose(): void;
}

export const LOGIN_TYPE = {
  GOOGLE: 'GOOGLE',
  FACEBOOK: 'FACEBOOK',
  LINKEDIN: 'LINKEDIN',
  GROWEXA: 'GROWEXA',
} as const;

export type ILoginType = ObjectValues<typeof LOGIN_TYPE>;
